import Header from '../partials/common/header/header';
import Footer from '../partials/common/footer/footer';
import About from "../partials/home/about";

function AboutPage() {
    return (
        <>
            <Header/>
            <About/>
            <Footer/>
        </>
    );
}

export default AboutPage;